import React, { useState, useEffect } from "react";
import { selectCurrentRoles } from "features/auth/authSlice";
import { useSelector } from "react-redux";
// import Products from './Products';
// import AgentsChart from './agents';
import InsuranceCharts from "./InsuranceCharts";
import { Typography, Tab, Tabs } from "@mui/material";
import InsuranceTableFilters from "./InsuranceTableFilters";
import InsuranceClaims from "./InsuranceClaims";
import { Input, Label } from "reactstrap";
import InsuranceClaimCharts from "./InsuranceClaimCharts";
const InsuranceAnalyticsDashboard = () => {
  const [value, setValue] = useState(0);

  const RolesFromToken = useSelector(selectCurrentRoles);
   const[activeButton,setActiveButton]=useState("Incurance_Analytics")
  const handleChange = (event, newValue) => {
    const selectedTabLabel = tabs[newValue].label;
    setValue(newValue);
  };
  const tabs = [{ label: "Analytics" }, { label: "Insurance"} ,{label:"Claims"}];

  return (
    <div>
      <Typography
        variant="h2"
        sx={{ fontWeight: 600, color: "#333", mb: 2, mx: 2 }}
      >
        Cattle Insurance Dashboard
      </Typography>
       <div className="d-flex justify-content-between">
      <Tabs
        value={value}
        onChange={handleChange}
        textColor="primary"
        indicatorColor="primary"
        sx={{ position: "relative" }}
        className="mx-3"
      >
        {tabs.map((tab, index) => (
          <Tab
            key={index}
            label={tab.label}
            sx={{
              fontSize: "14px",
              fontWeight: 500,
              textTransform: "capitalize",
              color: "#555",
              "&.Mui-selected": {
                color: "#333", // Selected color
                fontWeight: 600,
              },
              position: "relative", // To ensure pseudo-element appears over the tab
              "&::after": {
                content: '""',
                position: "absolute",
                bottom: -2, // Adjust to position the underline closer to the border
                left: 0,
                width: "100%",
                height: 2, // Thickness of the underline
                backgroundColor: "#007bff", // Underline color
                opacity: 0, // Initially hidden
                transition: "opacity 0.3s ease-in-out", // Smooth transition
              },
              "&.Mui-selected::after": {
                opacity: 1, // Underline appears when selected
              },
            }}
          />
        ))}
      </Tabs>
        {value===0 &&
      <div className="d-flex align-items-center bg-white rounded-3 mx-3 border">
              <div className="">
                <Input
                  type="radio"
                  value="Incurance_Analytics"
                  className="form-check-input mx-2  f500"
                  checked={activeButton === "Incurance_Analytics"}
                  onClick={() => setActiveButton("Incurance_Analytics")}
                />
                <Label className="form-check-label f600">
                 Insurance
                </Label>
              </div>
              <div className="me-2">
                <Input
                  type="radio"
                  value="Claims_Analytics"
                  className="form-check-input mx-2 f500"
                  checked={activeButton === "Claims_Analytics"}
                  onClick={() => setActiveButton("Claims_Analytics")}
                />
                <Label className="form-check-label f600">
                  Claims
                </Label>
              </div>

          
            </div>
            } 
      </div>
      {value === 0 && activeButton==="Incurance_Analytics" ? <InsuranceTableFilters activeButton={activeButton} /> 
       :value===0 && activeButton==="Claims_Analytics" ? <InsuranceClaimCharts activeButton={activeButton}/>
        :value===1 ? <InsuranceCharts/>
      :<InsuranceClaims/>
       }
    </div>
  );
};

export default InsuranceAnalyticsDashboard;
